export default __webpack_public_path__ + "static/media/PRODUIT_CHIMIQUE.7e863b0d.jpg";